/**
 * Cloud Function to delete a user from Firebase Authentication
 * This function should be deployed to Firebase Cloud Functions
 *
 * Deploy with: firebase deploy --only functions
 *
 * The function is called from the client when an admin deletes an authorized user
 */

import { httpsCallable, getFunctions } from "firebase/functions";
import { app } from "../firebaseConfig";

/**
 * Call the Cloud Function to delete a user from Firebase Authentication
 *
 * @param email - The email of the user to delete from Authentication
 * @returns Promise with the result
 *
 * Note: The Cloud Function "deleteAuthorizedUserFromAuth" must be deployed first
 * See functions/src/deleteAuthorizedUserFromAuth.ts for the implementation
 */
export const deleteUserFromAuthentication = async (
	email: string
): Promise<{ success: boolean; message: string }> => {
	try {
		const functions = getFunctions(app);
		const deleteUserFunction = httpsCallable<
			{ email: string },
			{ success: boolean; message: string }
		>(functions, "deleteAuthorizedUserFromAuth");

		const result = await deleteUserFunction({ email });
		return result.data;
	} catch (error) {
		console.error("Error calling deleteUserFromAuth function:", error);
		// Return error but don't throw - the user is already deleted from database
		return {
			success: false,
			message: `User removed from authorized list but could not delete from Authentication: ${error}`
		};
	}
};
